// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2jm5S","header":"PatientQuestionnaire_header__2VX7W","info":"PatientQuestionnaire_info__1c6Pv"};